module.exports = __webpack_public_path__ + "static/img/w2.6026664.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/w2.png
// module id = eXDO
// module chunks = 0